<template>
  <v-dialog
    v-model="dialog"
    dark
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="showDesc"
        outline
        @click="getPdf"
        @click.stop="on.click"
      >
        {{ $('TrainingClient.TaskList.Personal1.CourseOutline') }}
      </v-btn>
      <v-btn
        v-else
        icon
        large
        @click="getPdf"
        @click.stop="on.click"
      >
        <v-icon color="deep-orange lighten-2">
          {{ mdiFileDocument }}
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <div class="d-flex pa-2">
        <v-spacer />
        <v-spacer />
        <v-btn
          v-if="$config.isBrowser"
          icon
          dark
          @click="downloadFile"
        >
          <v-icon>
            {{ mdiDownload }}
          </v-icon>
        </v-btn>
        <v-spacer />
        <v-btn
          icon
          dark
          @click="dialog = false"
        >
          <v-icon>{{ mdiClose }}</v-icon>
        </v-btn>
      </div>
      <v-container class="pa-0">
        <div
          v-if="!loadCompleted"
          class="text-center mt-2"
        >
          <v-progress-circular
            size="50"
            color="primary"
            indeterminate
          />
        </div>
        <pdf
          v-for="i in numPages"
          :key="i"
          :page="i"
          :src="src"
          style="width:100%;"
          :scale="'page-width'"
        />
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import pdf from 'vue-pdf'
import { mdiFileDocument, mdiClose, mdiDownload } from '@mdi/js'
import Axios from 'axios'
// import { mapState } from 'vuex'

export default {
  components: {
    pdf
  },
  props: {
    showDesc: {
      type: Boolean,
      default: false
    },
    url: {
      // type: String,
      type: undefined,
      required: true
    }
  },
  data () {
    return {
      dialog: false,
      src: null,
      numPages: 0,
      loadCompleted: false,
      mdiFileDocument: mdiFileDocument,
      mdiClose: mdiClose,
      mdiDownload: mdiDownload,
      downloading: false
    }
  },
  mounted () {
    // this.src.then(pdf => {
    //   this.numPages = pdf.numPages
    // })
  },
  methods: {
    getPdf () {
      this.src = pdf.createLoadingTask(this.url)
      this.src.then(pdf => {
        this.numPages = pdf.numPages
        this.loadCompleted = true
      })
    },
    async downloadFile () {
      let url = await this.getFileFromServer(this.url)

      // out = new Blob([resp.data])

      let fileName = 'course.pdf'

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      link.click()
      window.URL.revokeObjectURL(url)
    },
    async getFileFromServer (url) {
      this.downloading = true
      return new Promise(resolve => {
        Axios.get(url, {
          responseType: 'blob'
        }).then(
          async resp => {
            this.downloading = false
            if (resp.status === 201 || resp.status === 200) {
              let out = resp.data
              if (out) {
                resolve(window.URL.createObjectURL(out))
              }
            }
          },
          error => {
            this.downloading = false
            console.log(error)
            // this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.DownloadFailed'))
          }
        )
      })
    }
  }
  // computed: {
  //   ...mapState({
  //     coursePdfUrl: state => state.courses.course.pcDetail.outlineDmsId
  //   })
  // }
}
</script>
